import { render } from "./noSideLayout.vue?vue&type=template&id=71008817"
import script from "./noSideLayout.vue?vue&type=script&lang=js"
export * from "./noSideLayout.vue?vue&type=script&lang=js"

import "./noSideLayout.vue?vue&type=style&index=0&id=71008817&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__